import { useState, useEffect } from 'react';

/**
 * useIsDesktop (T-120) — breakpoint reactivo compartido (>=1024px).
 *
 * Reactivo a proposito: rotar una tablet debe cambiar el MODO de la UI
 * (columna vs drawer, barra completa vs compacta), asi que matchMedia con
 * listener, no un window.innerWidth leido una sola vez.
 *
 * El try/catch cae a `true` (desktop) cuando matchMedia no existe — p.ej.
 * jsdom en los tests, donde queremos la UI completa.
 */
export default function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() => {
    try { return window.matchMedia('(min-width: 1024px)').matches; } catch { return true; }
  });
  useEffect(() => {
    let mq;
    try { mq = window.matchMedia('(min-width: 1024px)'); } catch { return undefined; }
    const onChange = (e) => setIsDesktop(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isDesktop;
}
